module.exports = __webpack_public_path__ + "img/Recurly.5cb61dfe.svg";